export default {
  styleOverrides: {
    root: {
      backgroundColor: '#fff',
    },
  }
}
